<template>
  <div>
    <c-search-box ref="searchbox" :isShowSearch="false" @enter="getList">
      <template slot="search">
        <div v-show="!processDisabled" class="col-6">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" @datachange="getList"/>
        </div>
        <div class="col-6">
          <c-process
            :editable="editable"
            :disabled="processDisabled"
            label="단위공정"
            name="subProcessCd"
            @datachange="getList"
            v-model="searchParam.subProcessCd">
          </c-process>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      :merge="popupParam.searchType=='1' ? grid1.merge : popupParam.searchType=='2' ? grid2.merge : popupParam.searchType=='3' ? grid3.merge : popupParam.searchType=='4' ? grid4.merge : popupParam.searchType=='5' ? grid5.merge : grid6.merge"
      :columns="popupParam.searchType=='1' ? grid1.columns : popupParam.searchType=='2' ? grid2.columns : popupParam.searchType=='3' ? grid3.columns : popupParam.searchType=='4' ? grid4.columns : popupParam.searchType=='5' ? grid5.columns : grid6.columns"
      :data="popupParam.searchType=='1' ? grid1.data : popupParam.searchType=='2' ? grid2.data : popupParam.searchType=='3' ? grid3.data : popupParam.searchType=='4' ? grid4.data : popupParam.searchType=='5' ? grid5.data : grid6.data"
      :gridHeight="grid1.height"
      :selection="popupParam.type"
      :filtering="true"
      :columnSetting="false"
      :isFullScreen="false"
      :isTitle="false"
      rowKey="idx"
    >
    </c-table>
    <div class="space-bottom-button"></div>
    <!-- 버튼 영역 -->
    <div class="search-box-btn">
      <q-btn-group outline >
        <c-btn label="선택" icon="check" color="teal-5" @btnClicked="select" />
      </q-btn-group>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'sop-pop',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          searchType: '1', // 1: 작업조회, 2:작업단계, 3:작업단계별 유해위험요인, 4:작업단계별 유해위험요인별 원인/결과, 5. 공정별 유해위험요인, 6. 단위공정별 유해위험요인 원인 / 결과
          subProcessCd: '',
          jobStepId: '',
          mdmHazardFactorsId: '',
        }
      },
    },
  },
  data() {
    return {
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      searchParam: {
        plantCd: null,
        subProcessCd: '',
        sopName: '',
        jobStepName: '',
        useFlag: 'Y',
        jobStepId: '',
        mdmHazardFactorsId: '',
      },
      grid1: {
        merge: [],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '작업명',
            align: 'left',
            sortable: false,
          },
          {
            name: 'sopNo',
            field: 'sopNo',
            label: '작업표준번호',
            align: 'center',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      grid2: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '작업명',
            align: 'left',
            sortable: false,
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            label: '작업단계',
            align: 'left',
            sortable: false,
          },
          {
            name: 'jobStepDesc',
            field: 'jobStepDesc',
            label: '작업방법(상세설명)',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      grid3: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
          { index: 2, colName: 'jobStepName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '작업명',
            align: 'left',
            sortable: false,
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            label: '작업단계',
            align: 'left',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      grid4: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'sopName' },
          { index: 2, colName: 'jobStepName' },
          { index: 3, colName: 'riskHazardName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'sopName',
            field: 'sopName',
            label: '작업명',
            align: 'left',
            sortable: false,
          },
          {
            name: 'jobStepName',
            field: 'jobStepName',
            label: '작업단계',
            align: 'left',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurReason',
            field: 'hazardOccurReason',
            label: '원인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurResult',
            field: 'hazardOccurResult',
            label: '결과',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      grid5: {
        merge: [
          { index: 0, colName: 'processName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      grid6: {
        merge: [
          { index: 0, colName: 'processName' },
          { index: 1, colName: 'riskHazardName' },
        ],
        columns: [
          {
            name: 'processName',
            field: 'processName',
            label: '공정명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'riskHazardName',
            field: 'riskHazardName',
            label: '유해위험요인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurReason',
            field: 'hazardOccurReason',
            label: '원인',
            align: 'left',
            type: 'html',
            sortable: false,
          },
          {
            name: 'hazardOccurResult',
            field: 'hazardOccurResult',
            label: '결과',
            align: 'left',
            type: 'html',
            sortable: false,
          },
        ],
        height: '400px',
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    processDisabled() {
      return Boolean(this.popupParam.subProcessCd);
    }
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid1.height = height + 'px'
    },
  },
  methods: {
    init() {
      switch(this.popupParam.searchType) {
        case '1':
          this.listUrl = selectConfig.mdm.sop.job.list.url;
          break;
        case '2':
          this.listUrl = selectConfig.mdm.sop.jobstep.url;
          break;
        case '3':
          this.listUrl = selectConfig.mdm.sop.jobhazard.url;
          break;
        case '4':
          this.listUrl = selectConfig.mdm.sop.jobhazardreason.url;
          break;
        case '5':
          this.listUrl = selectConfig.mdm.sop.processHazard.url;
          break;
        case '6':
          this.listUrl = selectConfig.mdm.sop.processHazardReason.url;
          break;
      }
      if (this.popupParam.subProcessCd) {
        this.searchParam.subProcessCd = this.popupParam.subProcessCd
      }
      if (this.popupParam.jobStepId) {
        this.searchParam.jobStepId = this.popupParam.jobStepId
      }
      if (this.popupParam.mdmHazardFactorsId) {
        this.searchParam.mdmHazardFactorsId = this.popupParam.mdmHazardFactorsId
      }
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        switch(this.popupParam.searchType) {
          case '1':
            this.grid1.data = _result.data;
            break;
          case '2':
            this.grid2.data = _result.data;
            break;
          case '3':
            this.grid3.data = _result.data;
            break;
          case '4':
            this.grid4.data = _result.data;
            break;
          case '5':
            this.grid5.data = _result.data;
            break;
          case '6':
            this.grid6.data = _result.data;
            break;
        }
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '잠재위험요인을 선택하세요.', // 잠재위험요인을 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    openPop(row) {
      this.popupOptions.title = '안전작업표준 상세'; // 작업허가서 상세
      this.popupOptions.param = {
        mdmSopId: row ? row.mdmSopId : '',
        tabpage: 'sopReport'
      };
      this.popupOptions.target = () => import(`${'@/pages/mdm/pim/sopDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '100%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
